﻿// --- START OF FILE App.jsx ---

import React from 'react';
import { Helmet } from 'react-helmet';
import { Toaster } from '@/components/ui/toaster';
import Header from '@/components/Header';
import Hero from '@/components/Hero';
import Services from '@/components/Services';
import Performance from '@/components/Performance';
import CaseStudy from '@/components/CaseStudy';
import About from '@/components/About';
// import Technology from '@/components/Technology'; // COMMENTED OUT: Removed as per request
import Contact from '@/components/Contact';
import Footer from '@/components/Footer';

function App() {
  return (
    <>
      <Helmet>
        {/* Meta tags remain the same */}
      </Helmet>
      
      <div className="min-h-screen bg-background text-foreground">
        <Header />
        <main>
          <Hero />
          <Services />
          <Performance />
          <CaseStudy />
          <About />
          {/* Removed: <Technology /> */}
          <Contact />
        </main>
        <Footer />
        <Toaster />
      </div>
    </>
  );
}

export default App;
// --- END OF FILE App.jsx ---